export default __webpack_public_path__ + "static/media/AnimalMondey02_02.b1066373.png";